import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Configuração pública do app web (não é segredo; o acesso é protegido
// pelas regras do Firestore e pela checagem de administrador).
const app = initializeApp({
  apiKey: "AIzaSyCtxqY77Zemi4-_wbet7TAel61d9hw_iYg",
  authDomain: "phelifla-chat.firebaseapp.com",
  projectId: "phelifla-chat",
  storageBucket: "phelifla-chat.firebasestorage.app",
  messagingSenderId: "803919627793",
  appId: "1:803919627793:web:50d318972cccc436fd13b0",
});

// Long polling evita bloqueios de rede/proxy no streaming do Firestore.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);
export const storage = getStorage(app);
